import React, { useState, useRef, useEffect } from 'react';
import Button from '../Button';
import TextInput from '../TextInput';
import './MFASetupModal.css';

const MFASetupModal = ({ isOpen, qrCode, secret, onVerify, onClose, loading, error }) => {
	const [code, setCode] = useState('');
	const [showQR, setShowQR] = useState(true);
	const codeInputRef = useRef(null);

	useEffect(() => {
		if (isOpen) {
			setCode('');
			setShowQR(true);
		}
	}, [isOpen]);

	useEffect(() => {
		if (isOpen && !showQR && codeInputRef.current) {
			setTimeout(() => {
				codeInputRef.current?.focus();
			}, 100);
		}
	}, [isOpen, showQR]);

	if (!isOpen) return null;

	const handleVerify = () => {
		if (code && code.trim().length === 6) {
			onVerify(code);
		}
	};

	const handleCodeChange = (e) => {
		const value = e.target.value.replace(/\D/g, '').slice(0, 6);
		setCode(value);
	};

	const handleKeyDown = (e) => {
		if (e.key === 'Enter' && code.length === 6 && !loading) {
			e.preventDefault();
			handleVerify();
		}
	};

	return (
		<div className='mfa_setup_overlay' onClick={onClose}>
			<div className='mfa_setup_container' onClick={(e) => e.stopPropagation()}>
				<div className='mfa_setup_content'>
					<h1 className='mfa_setup_title'>Two-Factor Authentication</h1>
					<p className='mfa_setup_subtitle'>
						Enter the 6-digit verification code from your authenticator app
					</p>

					{showQR && (
						<>
							<div className='mfa_setup_step'>
								<div className='mfa_setup_step_title'>Scan QR Code</div>
								<p className='mfa_setup_step_description'>
									Use Google Authenticator or Microsoft Authenticator to scan this QR code:
								</p>
								{qrCode && (
									<div className='mfa_qr_code_container'>
										<img src={qrCode} alt='MFA QR Code' className='mfa_qr_code' />
									</div>
								)}
							</div>

							<div className='mfa_setup_step'>
								<div className='mfa_setup_step_title'>Or Enter Secret Manually</div>
								<p className='mfa_setup_step_description'>
									If you can't scan the QR code, enter this secret in your authenticator app:
								</p>
								<div className='mfa_secret_container'>
									<div className='mfa_secret_text'>{secret}</div>
								</div>
							</div>
						</>
					)}

					<div className='mfa_setup_step'>
						<div className='mfa_setup_step_title'>Verification Code</div>
						<div className='mfa_code_input_container'>
							<TextInput
								ref={codeInputRef}
								placeholder='000000'
								value={code}
								onChange={handleCodeChange}
								onKeyDown={handleKeyDown}
								maxLength={6}
								autoFocus={!showQR}
								style={{ fontSize: '20px', letterSpacing: '8px', textAlign: 'center' }}
							/>
							{error && (
								<p style={{ color: '#ff5252', fontSize: '13px', marginTop: '10px' }}>
									{error}
								</p>
							)}
						</div>
					</div>

					<div className='mfa_buttons'>
						{onClose && (
							<Button
								label='CANCEL'
								onClick={onClose}
								style={{
									backgroundColor: '#4a4a4a',
									color: '#ffffff',
									border: 'none',
									padding: '12px 28px',
								}}
							/>
						)}
						<Button
							label='VERIFY'
							onClick={handleVerify}
							disabled={code.length !== 6 || loading}
							style={{
								backgroundColor: '#c41e3a',
								color: '#ffffff',
								border: 'none',
								padding: '12px 28px',
								opacity: code.length !== 6 || loading ? 0.6 : 1,
							}}
						/>
					</div>
				</div>

				<div className='mfa_setup_logo_section'>
					<img src='/assets/logo-new.png' alt='Watcher Logo' className='mfa_setup_logo' />
				</div>
			</div>
		</div>
	);
};

export default MFASetupModal;

